import { FC, SVGProps } from 'react'

const SaveAsIcon: FC<SVGProps<SVGSVGElement>> = svgProps => {
  return (
    <svg
      width="17"
      height="15"
      viewBox="0 0 17 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...svgProps}
    >
      <rect y="0.703735" width="14" height="14" rx="2" fill="currentColor" />
      <ellipse cx="6.98337" cy="11.3851" rx="2.20212" ry="2.29009" fill="white" />
      <path
        d="M1.6875 3.65961C1.6875 2.80715 2.37856 2.11609 3.23102 2.11609H7.63564C8.4881 2.11609 9.17916 2.80715 9.17916 3.65961V3.71231C9.17916 4.56477 8.4881 5.25582 7.63564 5.25582H3.23102C2.37856 5.25582 1.6875 4.56477 1.6875 3.71231V3.65961Z"
        fill="white"
      />
      <circle cx="11.6752" cy="4.81522" r="4.51895" fill="white" />
      <path
        d="M11.6758 2.46411V7.16638"
        stroke="currentColor"
        strokeWidth="1.3"
        strokeLinecap="round"
      />
      <path
        d="M9.32422 4.81525L14.0265 4.81525"
        stroke="currentColor"
        strokeWidth="1.3"
        strokeLinecap="round"
      />
    </svg>
  )
}

export default SaveAsIcon
